<template>
    <div>
        {{ this.$t('global.pagination.resultsString', { name: paginatedItemString, start, end, total }) }}
    </div>
</template>

<script>
    export default {
        props: {
            current: {
                type: Number,
                required: true,
            },
            paginatedItemName: {
                type: String,
                default: '',
            },
            perPage: {
                type: Number,
                required: true,
            },
            total: {
                type: Number,
                required: true,
            },
        },

        computed: {
            paginatedItemString() {
                return this.paginatedItemName || this.$t('global.pagination.results');
            },

            start() {
                const estimatedLowEnd = 1 + ((this.current - 1) * this.perPage);

                return this.total < estimatedLowEnd ? this.total : estimatedLowEnd;
            },

            end() {
                const estimatedHighEnd = this.perPage * this.current;

                return this.total < estimatedHighEnd ? this.total : estimatedHighEnd;
            },
        },
    };
</script>
